import React from 'react';

import { NumberFields } from 'jbc-front/components/Form';

const OrganizationNumber = ({ required }) => (
  <NumberFields
    label="雇用保険番号（事業所番号）"
    texts={['', ' - ']}
    lengths={[4, 6, 1]}
    required={required}
    seperateChar=""
    exactLength
    prefix="organizationNumberPart"
  />
);

export default OrganizationNumber;
